import React from 'react';
import { Tooltip } from 'doraemon';
import {
  formatString,
} from '@zcy/util-store';
import './index.less';

export default function TextWithTooltip (props) {
  const { text, style = {}, placement = 'top' } = props;
  return (
    <Tooltip title={ text } placement={ placement } >
      <span className="text-content" style={ style }>{formatString(text)}</span>
    </Tooltip>
  );
}
